import * as $ from 'jquery'
import { VSWebClient } from '../base/vsweb-client-impl'
import { Buffer } from 'buffer';

declare var vsClient: VSWebClient
declare function unescape(any): any;

export interface CommandInstance {
    sendXML: Function
    sendInstanceCommand: (xml: string) => void
    sendSetQualityCommand: (xml: string) => void
    executeXML: (xml: string) => void
    executeXMLNoMirror: (xml: string) => void
    executeXMLMouse: (xml: string) => void
    executeXMLAsync: (xml: string) => void
    executeXMLMouseMove: (xml: string, inFly?: boolean) => void
    resetMouseMove: () => void
    setMouseMove: (reset: boolean) => void
    executeXMLMouseWheel: (mouseX: number, mouseY: number, delta: number) => void
    resetMouseWheel: () => void
    setMouseWheel: (reset: boolean) => void
    executeXMLZoomMouseWheel: (mouseX: number, mouseY: number, delta: number) => void
    allowSending: Function
    CreateGetFolderContentPacket: (path: string, from: number, to: number, sorttype: number) => any;
    CreateGetFolderFileCountPacket: (path: string) => any
    logMousemove: (log: boolean) => void;
    destroy: () => void;
}

function createMessage(type, call) {
    return "<Request Type='" + type + "'>" + call + "</Request>";
}

function convertNumberToBigEndianUInt32(num, Bytes) {
    for (var i = 0; i < 4; i++) {
        Bytes.push(num & 0xFF)
        num >>= 8
    }
}

export function Command(ws: WebSocket, client) {
    var self = this
    var websocket
    // this string holds the XML commands to send to the server
    var vsClient = client as VSWebClient
    var XMLCommands = ''
    var XMLMouseCommands = []

    var XMLMouseMoveCommand = ''
    var XMLMouseWheelCommand = ''

    var XMLNoMirror = false;

    var mouseWheelDeltaUnsend = 0

    var toSend: boolean = true
    websocket = ws

    var nTicker = 0
    var nTimeOutTicks = 100
    // it might still be possible that messages in the client<->server communication are not in the correct order or missing.
    // this would result in stalling the sending process.
    // the timeout will enable sending a command - if available - after 2 seconds (nTimeOut = 100  [currently 50 ticks per second]) of waiting.

    var keepAliveTimeout = null
    var keepAlive = null

    var pingWorker = new Blob([
        "onmessage = function(e) { setTimeout(() => {postMessage('pong');}, 10000); }"]);

    // Obtain a blob URL reference to our worker 'file'.
    var blobURL = window.URL.createObjectURL(pingWorker);

    var worker = new Worker(blobURL);
    worker.onmessage = function (e)
    {
        sendKeepAlive();
        worker.postMessage('ping');
    };
    worker.postMessage('ping'); // Start the worker.

    var doLogMousemove = true;
    var moveIndex = 0;
    var tmpMove = undefined;
    var wheelIndex = 0;
    var tmpWheel = undefined;

    var noMouseMove = false

    var isDestroyed = false;

    this.destroy = function () {
        stopKeepAlive();
        isDestroyed = true;
    };

    this.logMousemove = function (log: boolean) {
        doLogMousemove = log;
    }

    this.sendXML = function () {

        if (websocket && websocket.readyState == 1 && !isDestroyed) {
            //Special workaround if a customer resizes the page while surpressing the window resize event
            //Was intended as an error fix for T-Systems but not used in the end (may be needed in the future)
            /*if (Math.abs(vsClient.vsCanvas.canvas2D.clientWidth - vsClient.vsCanvas.width) > 10)
            {
                vsClient.resize(vsClient.vsCanvas.canvas2D.clientWidth, vsClient.vsCanvas.canvas2D.clientHeight);
            }
            */
            if (XMLCommands.length != 0 || (XMLMouseMoveCommand && XMLMouseMoveCommand.length != 0) || XMLMouseWheelCommand.length != 0 || XMLMouseCommands.length != 0) {

                stopKeepAlive()

                var CallType = "XMLCall"

                if (XMLCommands.length === 0 || XMLNoMirror) {
                    CallType = "XMLCallNoMirror";
                    XMLNoMirror = false;
                }
                if (toSend || nTicker >= nTimeOutTicks) {
                    toSend = false

                    XMLCommands += XMLMouseWheelCommand

                    XMLCommands += XMLMouseMoveCommand

                    XMLCommands += XMLMouseCommands.join('')

                    const message = createMessage(CallType, XMLCommands);
                    if (doLogMousemove && !noMouseMove) {
                        for (let i = 0; i < XMLMouseCommands.length; i++) {
                            let mouseMessage = createMessage(CallType, XMLMouseCommands[i]);
                            vsClient.emit('@sendXML', mouseMessage, Date.now());
                        }
                        if (XMLMouseWheelCommand) {
                            vsClient.emit('@sendXML', createMessage(CallType, XMLMouseWheelCommand), Date.now());
                        }
                        if (XMLMouseMoveCommand) {
                            vsClient.emit('@sendXML', createMessage(CallType, XMLMouseMoveCommand), Date.now());
                        }
                    }
                    XMLMouseCommands = []
                    XMLMouseMoveCommand = ""
                    XMLMouseWheelCommand = ""
                    noMouseMove = false

                    websocket.send(message);

                    XMLCommands = ""
                    nTicker = 0
                }
            }

            //workaround for javascript setinterval execution stopp on window closes or browser tab in the background
            //starting new KeeppAlive using SetTimeout afer 10 seconds
            ++nTicker
            startKeepAlive()

        }
        else if (nTicker >= nTimeOutTicks) {

            stopKeepAlive()

            XMLCommands = ""
            XMLMouseCommands = []
            XMLMouseMoveCommand = ""
            XMLMouseWheelCommand = ""
            console.error("No Websocket communication available")
            nTicker = 0
        }
    }

    this.executeXML = function (command) {

        //Connection indicator animate
        if (!XMLMouseMoveCommand && XMLMouseCommands.length === 0) {
            $(".ws_indicator").addClass("ws_indicator_animate")
        }

        const message = createMessage("XMLCall", command);
        vsClient.emit('@sendXML', message, Date.now());
        noMouseMove = true;

        XMLCommands += XMLMouseWheelCommand + XMLMouseMoveCommand + XMLMouseCommands.join('') + command
        XMLMouseWheelCommand = ""
        XMLMouseMoveCommand = ""
        XMLMouseCommands = []
    }

    this.executeXMLNoMirror = function (command) {

        //setting XMLNoMirror flag, same XMLCallNoMirror used for MouseMove in sendXML 
        XMLNoMirror = true;
        self.executeXML(command);
    }

    function sendKeepAlive() {
        if (websocket && websocket.readyState == 1) {
            // let pingPacket = makePing()
            let pingPacket = vsClient.makePing(0)
            // websocket.send(pingPacket.buffer)
        }
    }

    function keepAliveTimeoutStep() {
        //KeepPAlive using SetTimeout - send ping for ws proxy keep alive every 10 seconds
        sendKeepAlive()
        keepAliveTimeout = setTimeout(function () { keepAliveTimeoutStep() }, 10000);
    }

    function startKeepAlive() {
        //start KeepPAlive using SetTimeout - send first ping for ws proxy keep alive after 10 seconds
        if (keepAliveTimeout == null) {
           // keepAliveTimeout = setTimeout(function () { keepAliveTimeoutStep() }, 10000);
        }
    }

    function stopKeepAlive() {
        if (keepAliveTimeout != null) {
            clearTimeout(keepAliveTimeout)
            keepAliveTimeout = null
        }
    }


    function makePing(): Uint8Array {
        let bytes = new Uint8Array(12)
        bytes.fill(0);

        bytes[10] = 1
        bytes[11] = 100
        return bytes
    }

    this.resetMouseMove = function () {
        moveIndex = 0;
        tmpMove = undefined;
        XMLMouseMoveCommand = '';
    }

    this.setMouseMove = function (reset: boolean) {
        if (reset) {
            moveIndex = 0;
            XMLMouseMoveCommand = tmpMove;
        }
        if (tmpMove) {
            XMLMouseMoveCommand = tmpMove;
        }
        else {
            moveIndex = 0;
        }
        tmpMove = undefined;
        /*if(tmpWheel)
        {
            XMLMouseWheelCommand = tmpWheel;
            tmpWheel = undefined;
        }*/
    }

    this.executeXMLMouseMove = function (command: string, inFly: boolean = false) {
        command = command.replace('Response="false"', 'Response="true"');
        command = command.replace('"MouseMove"', '"MouseMove" CustomId="' + moveIndex + '"');
        if ((moveIndex === 0 && XMLMouseMoveCommand !== command))// || inFly)
        {
            XMLMouseMoveCommand = command;
        }
        else
        {
            tmpMove = command;
        }
        moveIndex++;
    }

    this.executeXMLMouse = function (command) {
        if (XMLMouseMoveCommand) {
            XMLMouseCommands.push(XMLMouseMoveCommand);
        }
        XMLMouseCommands.push(command);
        this.resetMouseMove();
        this.resetMouseWheel();
    }

    this.resetMouseWheel = function () {
        wheelIndex = 0;
        tmpWheel = undefined;
        XMLMouseWheelCommand = '';
        mouseWheelDeltaUnsend = 0;
    }

    this.setMouseWheel = function (reset: boolean) {
        if (reset) {
            wheelIndex = 0;
            XMLMouseWheelCommand = tmpWheel;
        }
        if (tmpWheel) {
            XMLMouseWheelCommand = tmpWheel;
        }
        else {
            wheelIndex = 0;
        }
        mouseWheelDeltaUnsend = 0;
        tmpWheel = undefined;
    }

    this.executeXMLMouseWheel = function (mouseX, mouseY, delta) 
    {
        var scaledDelta = delta / 50 
        mouseWheelDeltaUnsend += scaledDelta;
        let command = '<Call Method="MouseWheel" Response="true" CustomId="' + wheelIndex + '"><X>' + mouseX + '</X><Y>' + mouseY + '</Y><Delta>' + mouseWheelDeltaUnsend + ' </Delta></Call>';
        //tmpWheel += command;
        //return
        if ((wheelIndex === 0 && XMLMouseWheelCommand !== command)) {
            XMLMouseWheelCommand = command;
        }
        else {
            tmpWheel = command;
        }
        wheelIndex++;
    }

    this.executeXMLZoomMouseWheel = function (mouseX, mouseY, delta) {
        mouseWheelDeltaUnsend += delta
        var scaledDelta = delta / 50
        XMLMouseWheelCommand = '<Call Method="MouseWheel" Response="false"><X>' + mouseX + '</X><Y>' + mouseY + '</Y><Delta>' + scaledDelta + ' </Delta></Call>';
    }

    this.executeXMLAsync = function (command) {
        self.sendXML() //Call this first to cleanup stack!

        // WS Connection indicator animate
        $(".ws_indicator").addClass("ws_indicator_animate")

        const message = createMessage("XMLCall", command);

        vsClient.emit('@sendXML', message, Date.now());
        websocket.send(message);
    }

    this.sendSetQualityCommand = function (command) {
        self.sendXML() //Call this first to cleanup stack!
        websocket.send(createMessage("SetQuality", command))
    }

    this.sendInstanceCommand = function (command) {
        self.sendXML() //Call this first to cleanup stack!

        websocket.send(createMessage("InstanceCommand", command))
    }

    //Undodocumented
    this.sendServerCommand = function (command) {
        self.sendXML() //Call this first to cleanup stack!

        websocket.send(createMessage("ServerCommand", command))
    }

    this.allowSending = function () {
        toSend = true
    }

    this.CreateGetFolderContentPacket = (
        path: string,
        from: number,
        to: number,
        sorttype: number
    ) =>
    {
        // fromTo has to be changed for lazy loading
        let Packet = [];

        convertNumberToBigEndianUInt32(from, Packet);
        convertNumberToBigEndianUInt32(to, Packet);
        convertNumberToBigEndianUInt32(sorttype, Packet);

        let buffer = new Buffer(Buffer.from(path, 'utf8'))
        for (let i = 0; i < buffer.length; i++)
        {
            Packet.push(buffer[i]);
        }

        let terminator = '\0';
        Packet.push(terminator.charCodeAt(0));

        return Packet;
    }

    this.CreateGetFolderFileCountPacket = (path: string) =>
    {
        let Packet = [];

        let buffer = new Buffer(Buffer.from(path, 'utf8'))
        for (let i = 0; i < buffer.length; i++)
        {
            Packet.push(buffer[i]);
        }

        let terminator = '\0';
        Packet.push(terminator.charCodeAt(0));

        return Packet;
    }
}